import request from '@/utils/request'
// 数据查询
// 仓库数据查询
export function findwarehouse(data) {
  return request({
    url: '/api/out/warehouse/findwarehouse',
    method: 'post',
    data
  })
}
// 仓库数据查询
export function pagewarehouse(data) {
  return request({
    url: '/api/out/warehouse/pagewarehouse',
    method: 'post',
    data
  })
}
// 仓库数据新增
export function addwarehouse(data) {
  return request({
    url: '/api/out/warehouse/addwarehouse',
    method: 'post',
    data
  })
}
// 仓库数据删除
export function deletewarehouse(data) {
  return request({
    url: '/api/out/warehouse/deletewarehouse',
    method: 'post',
    data
  })
}
// 仓库数据修改
export function updatewarehouse(data) {
  return request({
    url: '/api/out/warehouse/updatewarehouse',
    method: 'post',
    data
  })
}

/**
 * 采集统计从数据库快照查询，避免查询页依赖Redis当前工单状态。
 */
export function scadaCollectStatList(query) {
  return request({
    url: '/api/produce/scadacollect/list',
    method: 'get',
    params: query
  })
}

/**
 * 详情按快照主键读取子表明细，避免列表接口承载设备级数据。
 */
export function scadaCollectStatDetail(id) {
  return request({
    url: '/api/produce/scadacollect/detail',
    method: 'get',
    params: { id }
  })
}
